import { Calendar, CreditCard, FileCheck2, KeyRound, UserRound, UserPlus } from "lucide-react";
import { Reveal, SectionHeading } from "./Reveal";

const steps = [
  {
    icon: Calendar,
    title: "Choose a date and time",
    body: "Pick the one-hour slot that suits you from the live calendar.",
  },
  {
    icon: UserRound,
    title: "Create your account",
    body: "Sign up or log back in — it takes under a minute.",
  },
  {
    icon: FileCheck2,
    title: "Complete your forms",
    body: "A short waiver and health questions, required before your first visit.",
  },
  {
    icon: CreditCard,
    title: "Pay securely",
    body: "A$50 launch price, paid by card at checkout. That's the booking locked.",
  },
  {
    icon: UserPlus,
    title: "Invite friends — optional",
    body: "Add up to five guests. Each accepts, completes their own forms and pays their own A$10.",
  },
  {
    icon: KeyRound,
    title: "Enjoy your hour. PIN in, PIN out.",
    body: "Pick the slot, pay once, and your reminder an hour before includes your temporary PIN for the rear gate and rear door. Everything relocks itself — no keys, no staff, no fuss.",
  },
];

const HowItWorks = () => {
  return (
    <section id="how-it-works" data-testid="how-it-works-section" className="py-24 md:py-32">
      <div className="mx-auto max-w-7xl px-5 sm:px-8">
        <div className="max-w-2xl">
          <SectionHeading
            overline="How booking works"
            title={
              <>
                From browse to ice bath in <em className="italic text-ember">six steps.</em>
              </>
            }
          />
        </div>

        <div className="mt-16 md:mt-20 grid sm:grid-cols-2 lg:grid-cols-3 gap-px bg-line/60 border border-line/60">
          {steps.map((step, i) => (
            <Reveal key={step.title} delay={i * 0.06} className="bg-ink">
              <div data-testid={`how-step-${i + 1}`} className="h-full p-8 md:p-10 group hover:bg-coal transition-colors duration-500">
                <div className="flex items-center justify-between">
                  <step.icon className="h-5 w-5 text-ember" aria-hidden="true" />
                  <span className="font-display italic text-3xl text-stone2/60 group-hover:text-ember transition-colors duration-500">
                    {String(i + 1).padStart(2, "0")}
                  </span>
                </div>
                <h3 className="mt-8 text-lg font-medium text-cream">{step.title}</h3>
                <p className="mt-2 text-sm font-light leading-relaxed text-sand">{step.body}</p>
              </div>
            </Reveal>
          ))}
        </div>

        <Reveal delay={0.15}>
          <p className="mt-8 text-sm font-light text-stone2">
            Every attendee completes their own waiver and health questions — no forms, no entry.
          </p>
        </Reveal>
      </div>
    </section>
  );
};

export default HowItWorks;
